import Vue from 'vue'
import Router from 'vue-router'
import {allPath} from './routeConfig'


Vue.use(Router)
// console.log(allPath)
let router = new Router({
  routes: allPath,
  mode:"history",
  // scrollBehavior(to, from, savedPosition) {
  //   console.log('to',to)
  //   return { x: 0, y: 0 }
  // }
})

router.beforeEach((to, from, next)=>{
  // console.log(to,from)
  Vue.prototype.$routeLength ++
  localStorage.setItem(process.env.VUE_APP_PREFIX+"purl",from.path);
  localStorage.setItem(process.env.VUE_APP_PREFIX+"curl",from.path);
  if(to.query.minit){
    Vue.prototype.$platform = "miniProgram"
  }
  if(to.meta.title) {
    document.title = process.env.VUE_APP_TITLE === "PRO" ? to.meta.title : to.meta.title + process.env.VUE_APP_TITLE
  }
  if(to.query.accessToken){
    let query = to.query;
    Vue.prototype.$registLogin(query.memberId,
      {
        accessToken: query.accessToken,
        refreshToken: query.refreshToken,
        accessTokenExpiration: query.accessTokenExpiration
      })
      next()
  }
  let refreshToken = localStorage.getItem(process.env.VUE_APP_PREFIX+"refreshToken")
  // console.log("platform",Vue.prototype.$platform)
  if(!refreshToken && to.meta.auth){
    // if(Vue.prototype.$platform === "miniProgram"){
    //   Vue.prototype.$wx.miniProgram.navigateTo({url:"/pages/login/login"})
    //   return 
    // }
    
    if(to.name === "orderDetail" && Vue.prototype.$platform === "miniProgram"){
      let pagefrom = "/pages/memberDetailwv/memberDetailwv";
      let orderIdStr = "&orderId=" + to.query.orderId;
      Vue.prototype.$wx.miniProgram.navigateTo({url:`/pages/login/login?pagefrom=${pagefrom}&urlstr=${to.name}${orderIdStr}`})
      return
    }
    
    next({path:"/login"})
  }
  // if(to.path === "/login"){
  //   if(Vue.prototype.$platform === "miniProgram"){
  //     console.log('from',from.fullPath)
  //     let fromarg = "";
  //     if(from.fullPath === "/"){
  //       fromarg = "/indexPage"
  //     }else{
  //       fromarg = from.fullPath
  //     }

  //     Vue.prototype.$wx.miniProgram.redirectTo({
  //       url: "../login/login?from="+encodeURIComponent(fromarg)
  //     })
  //     return
  //   }

  // }
  next()
}) 
const {aplus_queue} = window;


router.afterEach((to, from) => {
  try{
    // console.log(aplus_queue,window)
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [{ is_auto: false } , to.path]
    });
  }catch(e){
    console.log(e)
  }
  let bodySrcollTop = document.body.scrollTop
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0
    return
  }
  let docSrcollTop = document.documentElement.scrollTop
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0
  }
  
})

window.$router = router

export default router